export const perspectiveOptions = [
  { value: 'category', text: 'Category' },
  { value: 'topic', text: 'Topic' },
];
